import { render, staticRenderFns } from "./CheckoutEndpointButton.vue?vue&type=template&id=6bf65490&scoped=true"
import script from "./CheckoutEndpointButton.vue?vue&type=script&lang=js"
export * from "./CheckoutEndpointButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf65490",
  null
  
)

export default component.exports